export default "__VITE_ASSET__Cf7OG8HS__"